import React, { useState } from "react";
import { Share2, Facebook, Link2, Check } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ title, image }) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch {}
    } else {
      setOpen((o) => !o);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true); toast.success("Връзката е копирана");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Неуспешно копиране"); }
  };

  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const pin = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(image || "")}&description=${encodeURIComponent(title || "")}`;
  const vb = `viber://forward?text=${encodeURIComponent(title + " " + url)}`;

  return (
    <div className="relative inline-block">
      <button onClick={nativeShare}
              className="inline-flex items-center gap-2 border border-navy text-navy hover:bg-navy hover:text-white transition-colors px-4 py-2.5 rounded-sm text-sm font-medium"
              data-testid="share-button">
        <Share2 size={16} /> Сподели
      </button>
      {open && (
        <div className="absolute z-30 mt-2 bg-white border border-stone shadow-lg rounded-sm p-2 flex gap-1" data-testid="share-menu">
          <a href={fb} target="_blank" rel="noreferrer" className="p-2 hover:bg-ivory rounded text-navy" title="Facebook" data-testid="share-facebook"><Facebook size={18} /></a>
          <a href={pin} target="_blank" rel="noreferrer" className="p-2 hover:bg-ivory rounded text-navy" title="Pinterest" data-testid="share-pinterest">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.4 0 0 5.4 0 12c0 5 3.1 9.3 7.4 11-.1-.9-.2-2.4 0-3.4l1.4-5.8s-.3-.7-.3-1.8c0-1.7 1-2.9 2.2-2.9 1 0 1.5.8 1.5 1.7 0 1-.7 2.6-1 4-.3 1.2.6 2.1 1.7 2.1 2 0 3.5-2.1 3.5-5.2 0-2.7-1.9-4.6-4.7-4.6-3.2 0-5.1 2.4-5.1 4.9 0 1 .4 2 .8 2.6.1.1.1.2 0 .3l-.3 1.2c0 .2-.2.3-.4.2-1.4-.6-2.2-2.6-2.2-4.2 0-3.4 2.5-6.6 7.1-6.6 3.7 0 6.6 2.7 6.6 6.2 0 3.7-2.3 6.7-5.6 6.7-1.1 0-2.1-.6-2.5-1.2l-.7 2.6c-.2 1-.9 2.2-1.4 3 1 .3 2.2.5 3.3.5 6.6 0 12-5.4 12-12S18.6 0 12 0z"/></svg>
          </a>
          <a href={vb} className="p-2 hover:bg-ivory rounded text-navy" title="Viber" data-testid="share-viber"><Link2 size={18} className="rotate-45" /></a>
          <button onClick={copyLink} className="p-2 hover:bg-ivory rounded text-navy" title="Копирай връзка" data-testid="share-copy">
            {copied ? <Check size={18} className="text-gold" /> : <Link2 size={18} />}
          </button>
        </div>
      )}
    </div>
  );
};
